import { Navigate } from "react-router-dom";

export default function PlanProtectedRoute({ children }) {
  const plan = localStorage.getItem("selectedPlan");

  if (!plan) {
    return <Navigate to="/choose-plan#pricing" replace />;
  }

  return children;
}
